import { useSelector,shallowEqual } from "react-redux";

const selectore = (state) => state.chatState;

export const useChatState = () => {
    const selectedData = useSelector(selectore, shallowEqual);
    return selectedData;
}